export default __webpack_public_path__ + "static/imgInformativa-5cf8909a2677c93d20f17f2d90a8aa6a.png";